module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAATtJREFUKBWdUk3KglAUPb5+BhWEMwXdgEizoFqDK3Cio3ATbkFcghto1qS5kQZBw2rYJAQFoUZB+H1X8KFRDTzwePfccw6Pd7lC8Q+0AGuRKSOtg93qRcuyMBwOK4ooijCbzTi/Xq9Yr9ecC57nFUmSIE1TGIbBhd1uh/l8zvl2u0Wn08FgMIDrumBxHMM0TYiiyE2fCsYYbNtGlmV4vV7o3u93PB4PkDAejxuZd/58PpHneelhuq5jsViUZDQaoTqapvGaeoTJZML/zYdDQv0FGtblcqH2R/Dg8XiE7/sfTdTc7/cNjQeDIIAsyw2xTm63W52iS5+dTqdQVRWSJDXEOqEhnk4nKIoCx3GAw+FQLJfLYrPZ0Np+xfl8Ln2r1ar0sH6/jzAMQfcv9Ho90BJUPoHivwLftNZL/gcTpIuZ8R75rAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/sillones.png
// module id = 516
// module chunks = 0